import React from 'react';
import './News.css'; 
import { Heading } from '../../../components';
import { images } from '../../../constants';
import news from '../../../constants/newsData'; 

import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

const fallbackImages = [
    images.news1,
    images.news2,
    images.news3,
    images.news4,
    images.news5,
    images.news6,
];

const getFallbackImage = (itemId) => fallbackImages[(itemId - 1) % fallbackImages.length];

const News = () => {
    return (
        <section className='news-section' id='aktualnosci'>
            <Heading title={'Aktualności'} subTitle={'O nas w mediach'} />

            {/* --- NOWA SEKCJA: ZAPROSZENIE --- */}
            <div className='invitation-container'>
                <div className='invitation-content'>
                    <h3 className='invitation-title'>Zaproszenie od Fundacji Dwór Imielno</h3>
                    <p>
                        Z ogromną radością zapraszamy Państwa na <strong>XVI Międzynarodowe Targi Tulipanów</strong>, 
                        które odbędą się w dniach <strong>1–3 maja w Chrzypsku Wielkim</strong> – miejscu, gdzie wiosna rozkwita najpiękniej!
                    </p>
                    <p>To wyjątkowe wydarzenie co roku przyciąga miłośników kwiatów i natury. Czekają na Państwa:</p>
                    <ul className='invitation-list'>
                        <li>🌷 setki odmian tulipanów w pełnym rozkwicie</li>
                        <li>🌱 inspiracje ogrodnicze i spotkania z pasjonatami</li>
                        <li>🛍️ możliwość zakupu unikatowych cebul i roślin</li>
                        <li>✨ niezapomniana atmosfera wśród pól kwiatowych</li>
                    </ul>
                    <p className='invitation-highlight'>
                        Tegoroczną edycję uświetni szczególne wydarzenie – <strong>uroczysty chrzest nowej odmiany tulipana „Robert Korzeniowski”</strong>. 
                        To moment, w którym świat ogrodnictwa spotyka się ze światem sportu.
                    </p>
                    <div className='invitation-footer'>
                        <p>📍 Chrzypsko Wielkie | 📅 1–3 maja</p>
                        <p><strong>Do zobaczenia wśród tulipanów!</strong></p>
                    </div>
                </div>

                <div className='invitation-images'>
                    {/* Tutaj podmień images.targi1 i targi2 na właściwe klucze z Twojego pliku constants */}
                    <img src={images.invitation1} alt="Targi Tulipanów 1" className='invitation-img' />
                    <img src={images.invitation2} alt="Targi Tulipanów 2" className='invitation-img' />
                </div>
            </div>
            {/* --- KONIEC SEKCJI ZAPROSZENIA --- */}

            <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                breakpoints={{
                    450: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1100: { slidesPerView: 3 },
                }}
            >
                {news.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div className='news-card'>
                            <div className='news-image'>
                                <img 
                                    src={
                                        item.image 
                                            ? item.image 
                                            : `https://api.microlink.io/?url=${encodeURIComponent(item.link)}&embed=image.url`
                                    }
                                    alt={item.title} 
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = getFallbackImage(item.id);
                                    }}
                                />
                                <span className='news-source'>{item.source}</span>
                            </div>
                            <div className='news-body'>
                                <h4>{item.title}</h4>
                                <p>{item.content}</p>
                                <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='news-link'
                                >
                                    Czytaj artykuł →
                                </a>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default News;